import { render, staticRenderFns } from "./MessageComponent.vue?vue&type=template&id=d05b5bd6&scoped=true&"
import script from "./MessageComponent.vue?vue&type=script&lang=js&"
export * from "./MessageComponent.vue?vue&type=script&lang=js&"
import style0 from "./MessageComponent.vue?vue&type=style&index=0&id=d05b5bd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05b5bd6",
  null
  
)

export default component.exports